import React, { useEffect, useMemo, Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../css/domainOverview.scss";
import FallbackLoader from "./FallbackLoader";
import { useTranslation } from "react-i18next";
const LazyKeywordsTable = lazy(() => import("../tables/KeywordsTable"));

function SEOKeyword({ type, title }) {
  const navigate = useNavigate();
  const keywords = useSelector((state) => state.seoKeyword);
  const keywordData = keywords?.keyword?.[type] || [];
  const email = useSelector((state) => state.email);
  const country = JSON.parse(sessionStorage.getItem("domainCountry"));
  const domainName = sessionStorage.getItem("lastdomainname");
  const { t } = useTranslation();

  const config = useMemo(() => {
    return {
      email,
      proj_name: domainName,
      tag_type: "site",
      location_name: country?.location_name,
      language_name: country?.language_name,
    };
  }, [email, domainName, country]);

  const siteDomainName = sessionStorage.getItem("lastdomainname");
  useEffect(() => {
    if (!siteDomainName) {
      navigate("/site-overview");
    } else {
      const element = document.getElementById("home_layout");
      if (element) {
        element.scrollTop = 0;
      } else {
        console.error(`Element with ID home_layout not found.`);
      }
    }
  }, [keywordData, siteDomainName, navigate]);

  const header = useMemo(() => {
    return [
      {
        id: "keyword",
        sort: "keyword",
        key: "keyword",
        tooltip: t("keyword_research.keyword_variations.table.keyword.tooltip"),
        minWidth: "300px",
        label: t("keyword_research.keyword_variations.table.keyword.title"),
        align: "left",
        isTrending: false,
        isAiWriter: false,
        show: true,
        ignore: true,
      },
      {
        id: "AI",
        key: "AI",
        tooltip: t("keyword_research.keyword_variations.table.ai.tooltip"),
        minWidth: "120px",
        label: t("keyword_research.keyword_variations.table.ai.title"),
        align: "center",
        isTrending: false,
        isAiWriter: true,
        show: true,
        ignore: true,
      },
      {
        id: "search_volume",
        key: "volume",
        sort: "search_volume",
        tooltip: t("keyword_research.keyword_variations.table.volume.tooltip"),
        minWidth: "120px",
        label: t("keyword_research.keyword_variations.table.volume.title"),
        align: "center",
        isTrending: false,
        isAiWriter: false,
        show: true,
        ignore: true,
      },
      {
        id: "rank_group",
        key: "position",
        sort: "rank_group",
        tooltip: t("rank_tracking.rank_tracker.table.columns.position.tooltip"),
        minWidth: "130px",
        label: t("rank_tracking.rank_tracker.table.columns.position.title"),
        align: "center",
        isTrending: false,
        isAiWriter: false,
        show: true,
        ignore: true,
      },
      {
        id: "last_updated",
        key: "last_updated",
        sort: "last_updated",
        tooltip: t("competitive_research.last_updated.tooltip"),
        minWidth: "150px",
        label: t("competitive_research.last_updated.title"),
        align: "center",
        isTrending: false,
        isAiWriter: false,
        show: true,
        ignore: true,
      },
    ];
  }, [t]);

  const rowData = useMemo(() => {
    return keywordData?.map((item) => {
      return {
        keyword: item.keyword,
        location_code: item?.location || false,
        search_volume: item.search_volume,
        rank_group: item.rank_group,
        is_new: item.is_new,
        is_lost: item.is_lost,
        last_updated: item.last_updated,
      };
    });
  }, [keywordData]);

  const keywordTableData = useMemo(() => {
    return {
      type: "site",
      addToRankTracking: true,
      header_name: {
        title: title,
        show: true,
      },
      header,
      row: rowData,
      config,
    };
  }, [header, rowData, title]);

  return (
    <React.Fragment>
      {siteDomainName ? (
        <Suspense fallback={<FallbackLoader />}>
          <LazyKeywordsTable Data={keywordTableData} />
        </Suspense>
      ) : (
        <FallbackLoader />
      )}
    </React.Fragment>
  );
}

export default SEOKeyword;
